export default {
  namespaced: true,

  state: () => ({
    currentProject: null,
    isLoadingProject: false,
    lastLoadedProjectId: null,
  }),

  getters: {
    project: (state) => state.currentProject,
    currentProject: (state) => state.currentProject,
    currentProjectId: (state) => state.currentProject?.projectId ?? state.currentProject?.id ?? null,
    isLoadingProject: (state) => state.isLoadingProject,
    hasProjectLoaded: (state) => !!state.currentProject,
  },

  mutations: {
    SET_PROJECT(state, project) {
      state.currentProject = project ?? null;
      state.lastLoadedProjectId =
        project?.projectId ?? project?.id ?? null;
    },
    SET_LOADING(state, isLoading) {
      state.isLoadingProject = !!isLoading;
    },
    RESET_PROJECT_STATE(state) {
      state.currentProject = null;
      state.isLoadingProject = false;
      state.lastLoadedProjectId = null;
    },
  },

  actions: {
    saveProject({ commit }, project) {
      commit("SET_PROJECT", project);
    },

    setCurrentProject({ commit }, project) {
      commit("SET_PROJECT", project);
    },

    updateProjectInStore({ commit }, updatedProject) {
      commit("SET_PROJECT", updatedProject);
    },

    resetProjectState({ commit }) {
      commit("RESET_PROJECT_STATE");
    },

    async loadProjectData() {
      return null;
    },
  },
};